import { colors, fonts } from '../theme'

export default function ProofBlock({ title, steps, result }) {
  return (
    <div style={styles.block}>
      {title && <div style={styles.title}>{title}</div>}
      <div style={styles.steps}>
        {steps.map((step, i) => (
          <div key={i} style={styles.step}>
            <span style={styles.stepNum}>{i + 1}.</span>
            <span style={styles.stepText}>{step}</span>
          </div>
        ))}
      </div>
      {result && (
        <div style={styles.result}>
          <span style={styles.resultLabel}>Result:</span> {result}
        </div>
      )}
    </div>
  )
}

const styles = {
  block: {
    padding: 16,
    background: colors.navyDeep,
    border: `1px solid ${colors.rule}`,
    borderLeft: `3px solid ${colors.gold}`,
    borderRadius: 3,
    fontFamily: fonts.mono,
    fontSize: 12,
  },
  title: {
    fontFamily: fonts.serif,
    fontSize: 13,
    fontWeight: 600,
    color: colors.gold,
    marginBottom: 10,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  steps: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  step: {
    display: 'flex',
    gap: 8,
    color: colors.textSecondary,
  },
  stepNum: {
    color: colors.textMuted,
    minWidth: 16,
  },
  stepText: {
    color: colors.textSecondary,
    lineHeight: 1.6,
  },
  result: {
    marginTop: 12,
    paddingTop: 10,
    borderTop: `1px solid ${colors.rule}`,
    color: colors.greenInk,
    fontWeight: 600,
  },
  resultLabel: {
    color: colors.gold,
  },
}
